import { cva } from 'class-variance-authority';

export { default as RawHtml } from './RawHtml.vue';

export const rawHtmlVariants = cva(
  'c-raw-html',
  {
    variants: {
      variant: {
        default: 'c-raw-html--left',
        leftWrapped: 'c-raw-html--left wrapper wrapper--content',
        center: 'c-raw-html--center',
        centerWrapped: 'c-raw-html--center wrapper wrapper--content',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);
